export const isDillProduct = (productType: string) => {
  return productType === "dill" || productType === "dill_cloud"
}
